$(document).ready(function () {
    var language = Mashie.Cookie.GetCookie("cookieLanguage") || 'sv-SE', momentLanguage = language;

    switch (language) {
        case "nb-NO":
            momentLanguage = "nn";
            $.datepicker.regional.no.dateFormat = "dd.mm.yy";
            $.datepicker.setDefaults($.datepicker.regional.no);
            break;

        case "en-GB":
            $.datepicker.setDefaults($.datepicker.regional["en-GB"]);
            break;

        case "da":
        case "da-DK":
            //$.datepicker.regional.da.dateFormat = "dd-mm-yy";
            moment.localeData('da')._longDateFormat.L = "DD-MM-YYYY";
            moment.localeData('da')._longDateFormat.l = "D-M-YYYY";
            $.datepicker.setDefaults($.datepicker.regional["da"]);
            break;
        case "fi":
        case "fi-FI":
            //$.datepicker.regional.fi.dateFormat = "d.m.yy";
            moment.localeData('fi')._longDateFormat.L = "D.M.YYYY";
            moment.localeData('fi')._longDateFormat.l = "D.M.YYYY";
            $.datepicker.setDefaults($.datepicker.regional["fi"]);

    default:
        momentLanguage = language = language.substring(0, 2);
        $.datepicker.setDefaults($.datepicker.regional[language]);
    }

    $.fn.datepicker.defaults.calendarWeeks = true;
    $.fn.datepicker.defaults.todayHighlight = true;
    $.fn.datepicker.defaults.weekStart = 1;

    $(document).trigger('reload-dates');
});

$(document).on('reload-dates', function () {
    // MS-1378: $.fn.datepicker here is bootstrap-datepicker (it wins the bundle load order;
    // buttonImage/showOn below are leftover jQuery-UI options it silently ignores). By default
    // it opens the calendar even on a readonly input (enableOnReadonly: true), which let users
    // pick dates on locked pages that were then silently discarded on postback.
    // enableOnReadonly: false makes the widget honor the readonly attribute on every (re)init -
    // including after each async postback, which is exactly when the lock was previously lost.
    $(".datePickerTextBox").datepicker('destroy').datepicker({
        calendarWeeks: true,
        todayHighlight: true,
        buttonImage: "../Images/calendar.gif",
        buttonImageOnly: true,
        showOn: "button",
        enableOnReadonly: false
    });

    $(".datePickerTextBoxWithoutValidation").datepicker('destroy').datepicker({
        calendarWeeks: false,
        todayHighlight: true,
        buttonImage: "../Images/calendar.gif",
        buttonImageOnly: true,
        showOn: "button",
        showWeek: true,
        enableOnReadonly: false
    });
});